import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { resolveImg } from '../api';
import { socials } from '../data/mock';
import { Sparkle } from 'lucide-react';

const StrassSection = () => {
  const { t, lang } = useLang();
  const { content } = useContent();
  const strass = content?.strass || [];

  const openBooking = () => window.open(socials.instagram, '_blank', 'noopener,noreferrer');

  return (
    <section id="strass" className="section-pad bg-white relative overflow-hidden border-t border-[#E8E2D5]">
      {/* Decorative sparkle bg */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]">
        <div className="absolute top-20 left-[10%]"><Sparkle size={48} className="text-[#957340]" /></div>
        <div className="absolute top-[40%] right-[15%]"><Sparkle size={32} className="text-[#957340]" /></div>
        <div className="absolute bottom-32 left-[20%]"><Sparkle size={40} className="text-[#957340]" /></div>
        <div className="absolute bottom-[20%] right-[30%]"><Sparkle size={24} className="text-[#957340]" /></div>
      </div>

      <div className="container-tight relative">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <span className="eyebrow">{t.strass.eyebrow}</span>
          <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 64px)' }}>
            {t.strass.title}
          </h2>
          <p className="text-[15px] text-[#3A3A3A] leading-[1.8] mt-6">{t.strass.subtitle}</p>
        </div>

        {strass.length === 0 ? (
          <div className="text-center py-20 border border-dashed border-[#E8E2D5] bg-[#FAF8F4] max-w-2xl mx-auto">
            <Sparkle size={28} className="mx-auto text-[#957340] mb-4" />
            <p className="serif text-[20px] text-[#1A1A1A]">{t.strass.empty}</p>
            <button onClick={openBooking} className="link-underline mt-6 inline-block">
              {lang === 'fr' ? 'Nous contacter' : 'Contact us'}
            </button>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {strass.map((s, i) => (
                <div key={s.id} className="bg-[#FAF8F4] border border-[#E8E2D5] overflow-hidden image-hover group">
                  <div className="aspect-square">
                    {s.img && <img src={resolveImg(s.img)} alt={s.nameFr} className="w-full h-full object-cover" />}
                  </div>
                  <div className="p-4">
                    <div className="flex items-baseline justify-between mb-1">
                      <h3 className="serif text-[17px] text-[#1A1A1A]">{lang === 'fr' ? s.nameFr : s.nameEn || s.nameFr || `Modèle ${i + 1}`}</h3>
                      {s.priceFrom && <span className="display text-[16px] text-[#957340]">{s.priceFrom}</span>}
                    </div>
                    <div className="text-[10px] tracking-[0.28em] uppercase text-[#957340]">{s.material || 'Swarovski'}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-14 text-center">
              <button onClick={openBooking} className="btn-primary">
                {lang === 'fr' ? 'Réserver une pose' : 'Book a session'}
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default StrassSection;
